module.exports = __webpack_public_path__ + "static/fipcmintorganic2-abf0b51e58afcd2f57965ca126945ce6.jpeg";